<div class="knowledge">
  <div class="knowledge__bar">
    <div class="knowledge__bar-info">
      <span class="knowledge__label">Arquivos enviados</span>
      <span class="knowledge__usage">
        <strong class="knowledge__usage-metric">{{ documentsUsageLabel }}</strong>
        <span aria-hidden="true">·</span>
        <strong class="knowledge__usage-metric">{{ storageUsageLabel }}</strong>
        <span aria-hidden="true">·</span>
        <span>PDF, TXT, MD e imagens</span>
        <span class="knowledge__limits-anchor">
          <button
            type="button"
            class="knowledge__limits-trigger"
            aria-label="Ver o que você pode enviar"
            [attr.aria-expanded]="isLimitsOpen"
            (mouseenter)="openLimits()"
            (mouseleave)="closeLimits()"
            (focus)="openLimits()"
            (blur)="closeLimits()"
            (click)="toggleLimits()"
          >
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </button>

          <div
            class="knowledge__limits"
            *ngIf="isLimitsOpen"
            (mouseenter)="openLimits()"
            (mouseleave)="closeLimits()"
          >
            <div class="knowledge__limits-panel">
              <span class="knowledge__limits-title">O que você pode enviar</span>
              <p class="knowledge__limits-text">
                Documentos PDF, arquivos de texto (.txt, .md) e imagens (JPG, PNG).
              </p>
              <span class="knowledge__limits-title">Limites de envio</span>
              <ul class="knowledge__limits-list">
                <li><span>Cada arquivo pode ter até</span><strong>50 MB</strong></li>
                <li>
                  <span>Você pode enviar até</span><strong>{{ maxDocuments }} arquivos</strong>
                </li>
                <li><span>Espaço total disponível</span><strong>500 MB</strong></li>
                <li><span>Documentos com até</span><strong>500 páginas</strong></li>
              </ul>
            </div>
          </div>
        </span>
      </span>
    </div>

    <button
      type="button"
      class="btn btn-primary knowledge__upload"
      [disabled]="isUploading"
      (click)="fileInput.click()"
    >
      <i
        class="fas"
        [class.fa-plus]="!isUploading"
        [class.fa-spinner]="isUploading"
        [class.fa-spin]="isUploading"
        aria-hidden="true"
      ></i>
      {{ isUploading ? 'Enviando…' : 'Enviar arquivos' }}
    </button>

    <input
      #fileInput
      type="file"
      multiple
      hidden
      [accept]="acceptAttribute"
      (change)="onFilesSelected($event)"
    />
  </div>

  <div class="knowledge__list" *ngIf="isLoading" aria-busy="true" aria-label="Carregando documentos">
    <div class="knowledge__skeleton" *ngFor="let i of [0, 1, 2]">
      <span class="knowledge__skeleton-icon"></span>
      <span class="knowledge__skeleton-line"></span>
      <span class="knowledge__skeleton-action"></span>
    </div>
  </div>

  <p class="knowledge__empty" *ngIf="!isLoading && !cards.length">
    Você ainda não enviou nenhum arquivo. Envie documentos para a AyA conhecer melhor o seu
    negócio.
  </p>

  <div class="knowledge__list" *ngIf="!isLoading && cards.length">
    <div class="knowledge__item" *ngFor="let card of cards; trackBy: trackByDocumentId">
      <i class="knowledge__icon" [ngClass]="iconClass(card.document)" aria-hidden="true"></i>

      <div class="knowledge__info">
        <span class="knowledge__name">{{ card.document.title }}</span>
        <span
          class="knowledge__detail"
          *ngIf="detailLabel(card.document)"
          [class.knowledge__detail--error]="card.document.status === statuses.Failed"
        >
          {{ detailLabel(card.document) }}
        </span>
      </div>

      <span class="knowledge__size">{{ formatSize(card.document.sizeBytes) }}</span>

      <span
        class="knowledge__status"
        [ngClass]="'knowledge__status--' + card.document.status"
        *ngIf="statusLabel(card.document)"
      >
        <span class="knowledge__status-dot" [class.knowledge__status-dot--pulsing]="isPending(card.document)"></span>
        {{ statusLabel(card.document) }}
      </span>

      <button
        type="button"
        class="knowledge__action"
        *ngIf="card.document.status === statuses.Failed"
        [disabled]="card.isBusy"
        [sgtTooltip]="'Processar novamente'"
        aria-label="Processar novamente"
        (click)="reprocess(card)"
      >
        <i class="fas fa-redo" aria-hidden="true"></i>
      </button>

      <button
        type="button"
        role="switch"
        class="knowledge__toggle"
        *ngIf="card.document.status === statuses.Ready"
        [class.knowledge__toggle--on]="card.document.enabled"
        [attr.aria-checked]="card.document.enabled"
        [disabled]="card.isBusy"
        [sgtTooltip]="card.document.enabled ? 'Em uso pela AyA' : 'Fora de uso'"
        [attr.aria-label]="card.document.enabled ? 'Em uso pela AyA' : 'Fora de uso'"
        (click)="toggleEnabled(card)"
      >
        <span class="knowledge__toggle-knob"></span>
      </button>

      <span class="knowledge__divider"></span>

      <button
        type="button"
        class="knowledge__action"
        [disabled]="card.isBusy"
        [sgtTooltip]="'Baixar arquivo'"
        aria-label="Baixar arquivo"
        (click)="download(card)"
      >
        <i class="fas fa-arrow-down" aria-hidden="true"></i>
      </button>

      <sgt-confirm-popover
        message="Excluir arquivo?"
        confirmLabel="Excluir"
        cancelLabel="Cancelar"
        variant="danger"
        position="bottom"
        (confirmed)="confirmDelete(card)"
      >
        <button
          type="button"
          class="knowledge__action knowledge__action--danger"
          [disabled]="card.isBusy"
          [sgtTooltip]="'Excluir'"
          aria-label="Excluir"
        >
          <i class="fas fa-trash" aria-hidden="true"></i>
        </button>
      </sgt-confirm-popover>
    </div>
  </div>
</div>
